<script lang="ts">
    import {onDestroy} from 'svelte'
    import Header from 'src/components/cabinet/#common/layout/Header.svelte'
    import Sidebar from 'src/components/cabinet/#common/layout/Sidebar.svelte'
    import Navbar from 'src/components/cabinet/#common/layout/Navbar.svelte'
    import {Link} from 'svelte-routing'
    import {autoScrollTop} from 'src/components/cabinet/#common/helpers'

    let year = new Date().getFullYear()

    if (typeof window !== 'undefined') {
        onDestroy(autoScrollTop({
            onPushState: true,
            onReloadPage: true,
        }))
    }
</script>

<div class="app">
    <Header/>
    <div class="content-wrapper">
        <Sidebar/>
        <slot name="content"/>
    </div>
    <Navbar/>
</div>

<style lang="postcss">
    div.app {
        font-family: 'Inter', sans-serif;
    }

    .app :global(.btn.btn-primary) {
        font-family: 'Inter', sans-serif;
    }

    .footer :global(.logo) {
        margin: 0 57px;
    }

    .footer :global(.menu-item) {
        font-family: 'Echoes Sans', sans-serif;
        font-size: 18px;
        line-height: 18px;
        color: white;
        text-decoration: none;
        transition: .25s;
    }

    .footer :global(.menu-item:not(:last-child)) {
        margin-right: 45px;
    }

    .footer :global(.menu-item:hover) {
        color: #dfdfdf;
    }

    .social-links a {
        color: white;
        font-size: 24px;
        display: inline-block;
        margin-left: 25px;
        line-height: 24px;
        vertical-align: top;
        transition: .25s;
    }

    .social-links a:hover {
        color: #dfdfdf;
    }

    .social-links a:first-child {
        margin-left: 0;
    }

    .footer :global(.footer-link) {
        font-size: 18px;
        color: white;
        text-decoration: none;
        line-height: 18.16px;
        font-family: "Echoes Sans", sans-serif;
        transition: .25s;
    }

    .footer :global(.footer-link:not(:last-child)) {
        margin-right: 42px;
    }

    .footer :global(.footer-link:hover) {
        color: #dfdfdf;
    }

    .app :global(.cabinet-wrapper) {
        padding: 130px 90px 50px 360px;
        line-height: normal;
    }

    .app {
        font-size: 18px;
        line-height: 18.16px;
        color: #1e1e1e;
        font-weight: 400;
        background: #212121;
        font-family: 'Manrope', sans-serif;

        :global {
            @import 'src/styles/app.pcss';
        }
    }

    .hamburger-btn span:first-child {
        margin-top: 0;
    }

    .hamburger-btn span:last-child {
        margin-bottom: 0;
    }

    .hamburger-btn span {
        height: 3px;
        background: white;
        width: 20px;
        margin: 5px 0;
        display: block;
        border-radius: 3px;
        transition: .25s;
    }

    .hamburger-btn.active span:nth-child(1) {
        transform: rotate(45deg) translate(3px, 8px);
        width: 26px;
    }

    .hamburger-btn.active span:nth-child(2) {
        opacity: 0;
    }

    .hamburger-btn.active span:nth-child(3) {
        transform: rotate(-45deg) translate(3px, -8px);
        width: 26px;
    }

    .content-wrapper {
        width: 100%;
        height: 100%;
        min-height: 100vh;
        background: #1c1a3f;
        color: white;
    }

    .content-wrapper :global(.page-subtitle) {
        color: #E0E0E0;
        font-size: 24px;
        margin-bottom: 30px;
    }

    .content-wrapper :global(.vertical-line) {
        position: relative;
    }

    .content-wrapper :global(.vertical-line:after) {
        content: "";
        background: #343168;
        height: 100%;
        width: 2px;
        position: absolute;
        right: 0;
        top: 0;
    }

    .app :global(.cabinet-wrapper .page-title) {
        font-size: 36px;
        font-weight: 600;
        color: white;
        border-bottom: 2px solid #343168;
        margin-bottom: 50px;
        padding-bottom: 30px;
    }

    @media(max-width: 1200px) {
        .header :global(.menu-item:not(:last-child)) {
            margin-right: 35px;
        }

        .app :global(.cabinet-wrapper .page-title) {
            margin-bottom: 40px;
            padding-bottom: 25px;
        }
    }

    @media(max-width: 992px) {
        .header :global(.menu-item) {
            font-size: 16px;
            line-height: 16px;
        }

        .app :global(.cabinet-wrapper .page-title) {
            font-size: 24px;
            margin-bottom: 30px;
        }

        .header :global(.menu-item) {
            font-size: 15px;
            line-height: 15px;
        }

        .header :global(.menu-item:not(:last-child)) {
            margin-right: 20px;
        }

        .app :global(.cabinet-wrapper) {
            padding: 75px 15px 15px 15px;
        }

        .app :global(.cabinet-wrapper .page-title) {
            font-size: 25px;
            padding-bottom: 15px;
        }

        .content-wrapper :global(.page-subtitle) {
            font-size: 20px;
            margin-bottom: 20px;
        }
    }

    @media(max-width: 767px) {
        .header-menu a {
            display: block;
            color: #1c1d21;
            font-size: 20px;
            padding: 0;
            margin: 20px 0;
            text-align: center;
            font-weight: 500;
        }

        .app :global(.cabinet-wrapper .page-title) {
            font-size: 24px;
            margin-bottom: 24px;
        }

        .header :global(.logo-icon) {
            width: 76px;
        }

        .footer :global(.menu-item) {
            font-size: 12px;
            line-height: 12.11px;
        }

        .footer :global(.menu-item:not(:last-child)) {
            margin-right: 10px;
        }

        .footer :global(.footer-link:not(:last-child)) {
            margin-right: 20px;
        }

        .footer :global(.footer-link) {
            font-size: 12px;
            line-height: 12.11px;
            margin: 0;
            display: inline-block;
        }

        .social-links a {
            font-size: 20px;
            margin-left: 20px;
        }

        .header :global(.menu-item:not(:last-child)) {
            margin-right: 0;
        }

        .header :global(.menu-item) {
            font-size: 16px;
            line-height: 16.14px;
        }

        .header :global(.menu-item) {
            font-size: 16px;
            line-height: 16px;
            display: block;
            text-align: center;
            width: 100%;
            padding: 25px;
            border-bottom: 1px solid #373737;
            position: relative;
            transition: .25s;
        }

        .header :global(.menu-item:last-child) {
            border-bottom: 0;
        }

        .header :global(.menu-item:before) {
            content: "";
            border-top: 1px solid transparent;
            position: absolute;
            width: 100%;
            left: 0;
            top: -1px;
            transition: .25s;
        }

        .header :global(.menu-item:hover:before) {
            border-color: #FF5D1C;
        }

        .header :global(.menu-item:after) {
            content: "";
            border-bottom: 1px solid transparent;
            position: absolute;
            width: 100%;
            left: 0;
            bottom: -1px;
            transition: .25s;
        }

        .header :global(.menu-item:hover:after) {
            border-color: #FF5D1C;
        }

        .header :global(.menu-item:hover) {
            color: #FF5D1C;
        }

        div.app {
            padding-bottom: 60px;
        }
    }
</style>

